import { QueryClient } from '@tanstack/react-query';

// Single QueryClient for the portal.
// Per-query overrides are still possible inside individual hooks.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat data as fresh for 1 minute. Most portal data doesn't change
      // instant-by-instant; tune higher per-query when appropriate.
      staleTime: 60_000,
      // Don't retry failed queries. The API interceptor already surfaces
      // errors via toast, and 4xx responses (e.g. 404 not found) won't
      // recover by retrying — retrying just doubles the request count.
      retry: 0,
      // Refetch when the tab regains focus so stale data refreshes itself.
      refetchOnWindowFocus: true,
    },
    mutations: {
      // Don't retry mutations — they're not idempotent (e.g. confirm appt).
      retry: 0,
    },
  },
});
